var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill-rule":"evenodd","fill":""}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"5"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }